import { render } from "./FormPurchaseOrder.vue?vue&type=template&id=66c270a0"
import script from "./FormPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./FormPurchaseOrder.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__